module.exports = __webpack_public_path__ + "media/images/8march-8e34b05505374575243ad7dfd24a0907.jpg";